export default __webpack_public_path__ + "locales/pt-BR/Article.json?hash=6561fcad5b0f0e424b33244b746f9783";